export const railsUrl = (filePath = '') => import.meta.env.VITE_RAILS_URL + filePath
